export default [
  {
    component: () => import("pages/organisations/OrganisationContractEdit.vue"),
    meta: {
      accessLevel: "organisation_edit",
      title: "Organisation Contract New Form",
    },
    name: "organisation-contracts-new",
    path: "/organisations/:organisationId/organisation-contracts/new",
    props: true,
  },
  {
    component: () => import("pages/organisations/OrganisationContractEdit.vue"),
    meta: {
      accessLevel: "organisation_edit",
      title: "Edit Organisation Contract",
    },
    name: "organisation-contracts-edit",
    path: "/organisations/:organisationId/organisation-contracts/:organisationContractId/edit",
    props: true,
  },
];
